// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

type VideoEncodingParameters = {
  maxBitrateKbps?: number;
  scaleResolutionDownBy?: number;
  maxFramerate?: number;
};

export default VideoEncodingParameters;
